import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { robotsOption, statusOption } from "../../../constant";
import { useAddProduct } from "./hooks";
import { useComponent, useElement, useLocale } from "../../../hooks";

export const AddProduct = () => {
  const { t } = useLocale();
  const Button = useElement("Button");
  const BackIcon = useElement("BackIcon");
  const DatePicker = useElement("DatePicker");
  const Editor = useElement("Editor");
  const Input = useElement("Input");
  const Box = useComponent("Box");
  const MediaBox = useComponent("MediaBox");
  const {
    productTitle,
    addProduct,
    title,
    addTitle,
    slug,
    setslug,
    sku,
    setsku,
    featuredVideo,
    setfeaturedVideo,
    hsn,
    sethsn,
    stock,
    setstock,
    content,
    setcontent,
    excerpt,
    setexcerpt,
    css,
    setcss,
    js,
    setjs,
    canonical,
    setcanonical,
    activeRobotsIndex,
    setrobots,
    metaTitle,
    setmetaTitle,
    metaDescription,
    setmetaDescription,
    setmetaKeyword,
    keywordOptions,
    metaKeyword,
    renderSlug,
    toggleRenderSlug,
    selectedTaxClass,
    settax,
    taxClassData,
    price,
    setprice,
    saleprice,
    setsaleprice,
    setinclusiveTax,
    inclusiveTax,
    setpublishDate,
    publishDate,
    setstatus,
    status,
    company,
    setcompany,
    companies,
    setisFeatured,
    isFeatured,
    setisAssured,
    isAssured,
    category,
    setcategory,
    categoryOption,
    brand,
    setbrand,
    brandOptions,
    tag,
    settag,
    tagOptions,
    image,
    setimage,
  } = useAddProduct();
  return (
    <div id="content-box" className="content">
      <h1>
        <BackIcon backLink="/admin/product/list" />
        {productTitle}
      </h1>
      <form className="columns" noValidate onSubmit={addProduct}>
        <div className="left">
          <Box title={t("title")} required>
            <Input
              autoFocus
              required
              name="title"
              value={title}
              onChange={addTitle}
            />
          </Box>
          <Box title="Slug" requirred>
            <Input
              required
              name="slug"
              value={slug}
              onChange={(e) => setslug(e.target.value)}
            />
          </Box>
          <Box title={t("sku")}>
            <Input
              name="sku"
              value={sku}
              onChange={(e) => setsku(e.target.value)}
            />
          </Box>
          <Box title={t("hsnCode")}>
            <Input
              name="hsn"
              value={hsn}
              onChange={(e) => sethsn(e.target.value)}
            />
          </Box>
          <Box title={t("stockAvailability")} required>
            <Input
              type="number"
              required
              name="stock"
              value={stock}
              onChange={(e) => setstock(e.target.value)}
            />
          </Box>
          <Box title="Content" required>
            <Editor
              value={content}
              onEditorChange={(content) => setcontent(content)}
            />
          </Box>
          <Box title={t("excerpt")} required>
            <Editor
              value={excerpt}
              onEditorChange={(excerpt) => setexcerpt(excerpt)}
            />
          </Box>
          <Box title="CSS">
            <textarea
              className="description"
              placeholder={t("placeholder.inlineCss")}
              required
              name="css"
              value={css}
              onChange={(e) => setcss(e.target.value)}
            ></textarea>
          </Box>
          <Box title="JS">
            <textarea
              className="description"
              placeholder={t("placeholder.inlineJs")}
              required
              name="js"
              value={js}
              onChange={(e) => setjs(e.target.value)}
            ></textarea>
          </Box>
          <Box title={t("canonicalUrl")}>
            <Input
              required
              name="canonical"
              value={canonical}
              onChange={(e) => setcanonical(e.target.value)}
            />
          </Box>
          <Box title={t("robots")}>
            <Select
              value={robotsOption[activeRobotsIndex]}
              defaultValue={robotsOption[activeRobotsIndex]}
              onChange={(e) => setrobots(e.value)}
              options={robotsOption}
            />
          </Box>
          <Box title={t("metaDescription")}>
            <textarea
              placeholder={t("placeholder.metaDescription")}
              required
              name="meta description"
              value={metaDescription}
              onChange={(e) => setmetaDescription(e.target.value)}
            ></textarea>
          </Box>
          <Box title={t("metaTitle")}>
            <Input
              required
              name="meta title"
              value={metaTitle}
              onChange={(e) => setmetaTitle(e.target.value)}
            />
          </Box>
          <Box title={t("metaKeywords")}>
            <CreatableSelect
              isMulti
              onChange={(e) => setmetaKeyword(e)}
              options={keywordOptions}
              value={metaKeyword}
            />
          </Box>
        </div>
        <div className="right">
          <Box title={t("meta")}>
            <p>
              {t("renderSlug")}:
              <span
                className={renderSlug ? "switch on" : "switch off"}
                title="Click to Enable/Disable auto slug rendering"
                onClick={toggleRenderSlug}
              ></span>
            </p>
            <Button
              className="btn btn-primary has-icon"
              type="submit"
              title="Click here to save"
            >
              {t("save")}
            </Button>
          </Box>
          {taxClassData.length > 0 && (
            <Box title={t("taxPercentage")} required>
              <Select
                value={selectedTaxClass}
                defaultValue={selectedTaxClass}
                onChange={(e) => settax(e.value)}
                options={taxClassData}
              />
            </Box>
          )}
          <Box title="MRP" required>
            <Input
              type="number"
              required
              name="price"
              min={0}
              value={price}
              onChange={(e) => setprice(e.target.value)}
            />
          </Box>
          <Box title={t("salePrice")}>
            <Input
              type="number"
              name="saleprice"
              min={0}
              value={saleprice}
              onChange={(e) => setsaleprice(e.target.value)}
            />
          </Box>
          <Box title={t("priceMeta")} required>
            <span
              className="pointer isFeatured"
              onClick={() => setinclusiveTax(!inclusiveTax)}
            >
              {inclusiveTax ? (
                <i className="icon-check orange hi-check-circle"></i>
              ) : (
                <i className="hi-circle icon-check"></i>
              )}
              Inclusive of all taxes{" "}
            </span>
          </Box>
          <Box title={t("publishDate")}>
            <DatePicker
              onChange={(publishDate) => setpublishDate(publishDate)}
              selected={publishDate}
            />
          </Box>
          <Box title="Status">
            <Select
              value={status}
              defaultValue={status}
              onChange={(e) => setstatus(e)}
              options={statusOption}
            />
          </Box>
          {status?.value === "private" && (
            <Box title="Company" required>
              <Select
                value={company}
                defaultValue={company}
                onChange={(e) => setcompany(e)}
                options={companies}
              />
            </Box>
          )}
          <Box title="Featured">
            <span
              className="pointer isFeatured"
              onClick={() => setisFeatured(!isFeatured)}
            >
              {isFeatured ? (
                <i className="icon-check orange hi-check-circle"></i>
              ) : (
                <i className="hi-circle icon-check"></i>
              )}
              {t("isFeatured")}
            </span>
          </Box>
          <Box title="Assured">
            <span
              className="pointer isAssured"
              onClick={() => setisAssured(!isAssured)}
            >
              {isAssured ? (
                <i className="icon-check orange hi-check-circle"></i>
              ) : (
                <i className="hi-circle icon-check"></i>
              )}
              Is Assured{" "}
            </span>
          </Box>
          <Box title="Category">
            <Select
              value={category}
              onChange={(e) => setcategory(e)}
              options={categoryOption}
              isMulti
            />
          </Box>
          <Box title="Brand">
            <Select
              value={brand}
              onChange={(e) => setbrand(e)}
              options={brandOptions}
            />
          </Box>
          <Box title="Tags">
            <CreatableSelect
              isMulti
              value={tag}
              onChange={(e) => settag(e)}
              options={tagOptions}
            />
          </Box>
          <MediaBox
            image={image}
            setimage={(image) => setimage(image)}
            usage={["product"]}
          />
          <Box title={t("featuredVideo")}>
            <Input
              name="featuredVideo"
              value={featuredVideo}
              onChange={(e) => setfeaturedVideo(e.target.value)}
            />
          </Box>
        </div>
      </form>
    </div>
  );
};
